import React from 'react';
import { Hero } from '../components/Hero';
import { ThreePillars } from '../components/ThreePillars';
import { ExplainerVideo } from '../components/ExplainerVideo';
import { HowItWorks } from '../components/HowItWorks';
import { PartnerDashboards } from '../components/PartnerDashboards';
import { WhatsAppCommunity } from '../components/WhatsAppCommunity';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { motion, useScroll, useSpring } from 'framer-motion';
export function LandingPage() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return <div className="min-h-screen bg-white font-sans text-brand-dark selection:bg-brand-primary/20 selection:text-brand-primary" data-id="element-748" data-mp="2fzdtfoml8de1">
      {/* Progress Bar */}
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-brand-primary origin-left z-50" style={{
      scaleX
    }} data-id="element-749" data-mp="qmk4p9gnl1ns" />

      <Navigation data-id="element-750" data-mp="2zk8997ore7me" />

      <main data-id="element-751" data-mp="2zkrt4txyz632">
        <Hero data-id="element-752" data-mp="2zh3yfrgsgdmr" />
        <ThreePillars data-id="element-753" data-mp="33kiiqubrfg60" />
        <ExplainerVideo data-id="element-754" data-mp="33jqxacbvmytg" />
        <HowItWorks data-id="element-755" data-mp="33l1yq5hunuhe" />
        <PartnerDashboards data-id="element-756" data-mp="33iftwdmcft2v" />
        <WhatsAppCommunity data-id="element-757" data-mp="38jvclz11tni3" />
      </main>

      <Footer data-id="element-758" data-mp="38itrt2u8dmn6" />
    </div>;
}